import { RootState } from '../rootReducer';
import { ContextMenu } from './actions';

export const getContextMenuState = (state: RootState): ContextMenu => state.contextMenu;
